import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["country", "className", "validationState", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as r } from "react/jsx-runtime";
import u from "react";
import m, { isPossiblePhoneNumber as c } from "react-phone-number-input/min";
import { InputText as a } from "../InputText/InputText.js";
import f from "./CountrySelect.js";
import { c as l } from "../../../clsx-OuTLNxxd.js";
const P = "PhoneInput-module_input__0Ce2t",
  h = {
    input: P
  },
  I = /* @__PURE__ */u.forwardRef(function (n, t) {
    return /* @__PURE__ */r(a, _objectSpread(_objectSpread({}, n), {}, {
      ref: t,
      variant: "default"
    }));
  }),
  b = /* @__PURE__ */u.forwardRef(function (_ref, i) {
    let {
        country: n,
        className: t,
        validationState: o = void 0,
        disabled: e = !1
      } = _ref,
      p = _objectWithoutProperties(_ref, _excluded);
    return /* @__PURE__ */r(m, _objectSpread({
      ref: i,
      placeholder: "Enter phone number",
      flags: void 0,
      defaultCountry: n,
      international: !1,
      inputComponent: I,
      countrySelectComponent: f,
      countrySelectProps: {
        validationState: o,
        disabled: e
      },
      numberInputProps: {
        validationState: o
      },
      className: l([h.input, t]),
      "data-testid": "phone-input",
      disabled: e
    }, p));
  }),
  R = b,
  v = c;
export { R as PhoneInput, v as isPossiblePhoneNumber };